import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';

import { GasModalComponent } from './modal/gas-modal.component';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';
import { GasButtonModule } from '../../forms/gas-button/gas-button.module';

const COMPONENTS = [
  GasModalComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    A11yModule,
    CommonModule,
    GasIconsModule,
    GasButtonModule,
  ],
  entryComponents: [
    COMPONENTS,
  ],
})
export class GasModalModule { }
